import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SidebarState } from './sidebar.reducer';

export const selectSidebarState =
   createFeatureSelector<SidebarState>('sidebar');

/**
 * Backward-compatible selector
 * Used by existing components
 */
export const selectSidebarExpanded = createSelector(
   selectSidebarState,
   (state) => state.isExpanded
);

/**
 * Canonical selectors
 */
export const selectSidebarMode = createSelector(
   selectSidebarState,
   (state) => state.mode
);

export const selectSidebarHidden = createSelector(
   selectSidebarState,
   (state) => state.mode === 'hidden'
);

export const selectSidebarCollapsed = createSelector(
   selectSidebarState,
   (state) => state.mode === 'collapsed'
);

export const selectSidebarVisible = createSelector(
   selectSidebarState,
   (state) => state.mode !== 'hidden'
);
